import { Button, Popover, Tooltip, Typography } from "@mui/material";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import { addItemStorage } from "../../redux/features/product.features";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

const ProductStoreDetails_Preview = ({ storageBox }) => {
  const printRef = useRef();
  let productState = useSelector((state) => {
    return state.productReducer;
  });

  let { products, ItemStorage } = productState;

  const [values, setValues] = useState(storageBox);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [overlayStorageItemList, setOverlayStorageItemList] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState(
    (ItemStorage && ItemStorage.storageSlot) || null
  );
  const dispatch = useDispatch();

  // const printLabel = useReactToPrint({
  //   pageStyle: `
  //   @media print{
  //     @page {

  //         size:landscape;

  //          }
  //     body{

  //         -webkit-print-color-adjust: exact;
  //     }
  //     section{

  //     background-color: white;
  // }

  // }
  //   `, // remove date/time from top

  //   // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
  //   content: () => printRef.current,
  // });

  const printLabel = useReactToPrint({
    pageStyle: `  
    @media print{
        ::-webkit-scrollbar {
            display: none;
          }
  
      
      body{
        -webkit-print-color-adjust: exact;
         
           
        
      }
   
  
  }
    `, // remove date/time from top

    // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
    content: () => printRef.current,
  });

  function setPageSize(cssPageSize) {
    const style = document.createElement("style");
    style.innerHTML = `@page { size: ${cssPageSize}`;
    style.id = "page-orientation";
    document.head.appendChild(style);
  }

  const [orientation, setOrientation] = useState("landscape"); //landscape
  useEffect(() => {
    setPageSize(orientation);
    return () => {
      const child = document.getElementById("page-orientation");
      child.parentNode.removeChild(child);
    };
  }, [orientation]);

  useEffect(() => {
    setRows(mapRowArray(Number(values.storageBoxRowSize)));
    setColumns(mapColumnArray(Number(values.storageBoxColumnSize)));
    setOverlayStorageItemList(
      products.filter((x) => x.storageBoxName === values.storageBoxName)
    );
  }, [values]);

  const selectSlots = (val) => {
    let itemStorage = {
      storageBoxName: values.storageBoxName,
      storageSlot: val,
      storageBoxRowSize: values.storageBoxRowSize,
      storageBoxColumnSize: values.storageBoxColumnSize,
    };
    setSelectedSlots(val);
    dispatch(addItemStorage(itemStorage));
  };

  const mapRowArray = (size) => {
    let rowName = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "W",
      "X",
      "Y",
      "Z",
    ];

    let arr = [];
    for (let index = 0; index < size; index++) {
      const element = rowName[index];
      arr.push(element);
    }
    return arr;
  };
  const mapColumnArray = (size) => {
    let arr = [];
    for (let index = 1; index < size + 1; index++) {
      // const element = rowName[index];
      arr.push(index);
    }
    return arr;
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const Grid = ({ overlayStorageItemList }) => {
    let boxName = "A";

    // let columns = [1, 2, 3, 4, 5];
    let count = 0;

    return (
      <div className="flex-col flex w-full">
        <div className="flex">
          <div className="flex w-full justify-evenly">
            <div className=" m-2 p-3 border border-2 text-center text-2xl">
              {values.storageBoxName}
            </div>
            {columns.map((y, i) => {
              i = i + 1;
              return (
                <div className=" text-white text-2xl font-extrabold flex justify-center items-center bg-gray-600 w-2/12 border-white m-2 p-2 text-center">
                  {i++}
                </div>
              );
            })}
          </div>
        </div>
        {rows.map((x) => {
          return (
            <div className="flex ">
              <div
                style={{ height: 88 }}
                className="flex w-full justify-evenly"
              >
                <div className=" text-white text-2xl font-extrabold lowercase bg-blue-400 m-2 p-3 border border-2 flex justify-center items-center text-center text-2xl">
                  {x}
                </div>
                {columns.map((y, i) => {
                  count = count + 1;
                  return (
                    <div className="flex justify-center items-center rounded-full text-white text-xl font-extrabold w-2/12 border-white m-2 p-2 text-center">
                      <div
                        onClick={() => {
                          if (
                            overlayStorageItemList.filter(
                              (z) =>
                                z.storageBoxName === values.storageBoxName &&
                                z.storageSlot &&
                                z.storageSlot.toString().toLowerCase() ===
                                  String(values.storageBoxName + x + y)
                                    .toString()
                                    .toLowerCase()
                            ).length !== 0
                          ) {
                            return alert(
                              "Cannot select already reserved slots, please select new slots"
                            );
                          } else {
                            selectSlots(`${values.storageBoxName}${x}${y}`);
                          }
                        }}
                        style={{ height: 65, width: 55 }}
                        className={`    ${
                          overlayStorageItemList.filter(
                            (z) =>
                              z.storageBoxName === values.storageBoxName &&
                              z.storageSlot &&
                              z.storageSlot.toString().toLowerCase() ===
                                String(values.storageBoxName + x + y)
                                  .toString()
                                  .toLowerCase()
                          ).length !== 0
                            ? "bg-red-500 cursor-not-allowed"
                            : "bg-green-500 cursor-pointer"
                        }  lowercase flex justify-center items-center rounded-full text-white text-xl font-extrabold p-2 ${
                          selectedSlots === values.storageBoxName + x + y
                            ? ""
                            : ""
                        } 
                       
                        `}
                      >
                        <div className="text-sm flex flex-col w-full justify-between">
                          {
                            overlayStorageItemList
                              .filter(
                                (z) =>
                                  z.storageBoxName === values.storageBoxName &&
                                  z.storageSlot &&
                                  z.storageSlot.toString().toLowerCase() ===
                                    String(values.storageBoxName + x + y)
                                      .toString()
                                      .toLowerCase()
                              )
                              .map((y) => {
                                return (
                                  <>
                                    
                                    <Tooltip arrow title={`${y.title} | Weight : ${y.weight}`}>
                                      <Typography variant="body1">
                                      {"#" + y.productId}
                                      </Typography>
                                    </Tooltip>
                                  </>
                                );
                              })[0]
                          }
                          <div>
                            <span className="uppercase">
                              {values.storageBoxName}
                            </span>
                            {x}
                            {y}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  // const items = storageBox.map((x) => x.storageBoxName);

  return (
    <div className="flex flex-col">
      <Button variant="contained" onClick={() => printLabel()}>
        Print
      </Button>

      <div className="flex flex-col w-full">
        <div className="flex"></div>
        <div ref={printRef} className="flex p-5">
          <Grid overlayStorageItemList={overlayStorageItemList} />
        </div>
      </div>
    </div>
  );
};

export default ProductStoreDetails_Preview;
